import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CookiesService } from 'src/app/services/cookies.service';
import { CookiesConfiguratorComponent } from '../cookies-configurator/cookies-configurator.component';

@Component({
  selector: 'app-cookies-configurator-modal',
  templateUrl: './cookies-configurator-modal.component.html',
  styleUrls: ['./cookies-configurator-modal.component.scss'],
})
export class CookiesConfiguratorModalComponent implements OnInit {
  constructor(private modalController: ModalController, private cookiesService: CookiesService) {}

  @Input() cookies;
  @ViewChild(CookiesConfiguratorComponent) configurator;

  ngOnInit() {}

  dismiss(saved?) {
    this.modalController.dismiss({
      dismissed: true,
      cookiesSaved: saved,
    });
  }

  saveAll() {
    this.configurator.saveAll();
    this.dismiss(true);
  }

  rejectAll() {
    this.configurator.rejectAll();
    this.cookiesService.closeCookies(false);
    this.dismiss(true);
  }

  saveCookiesSettings() {
    this.configurator.saveCookiesSettings();
    this.cookiesService.closeCookies(true);
    this.dismiss(true);
  }
}
